<template>
    <div>
        <!-- <h1>Formulario de alta de CFJ para aspirante {{ aspiranteId }}</h1> -->
        
        <form @submit.prevent="save" enctype="multipart/form-data" class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden">
            <div class="px-10 py-12">
                <h1 class="text-center font-bold mb-8">Formulario de alta de CFJ para aspirante {{ aspirante.id }}</h1>
                <text-input required v-model="form_cursos_cfj.curso" class="pr-6 pb-8 w-full lg:w-1/2" label="Curso" />
                <text-input v-model="form_cursos_cfj.descripcion" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripción" />
                <file-input v-model="form_cursos_cfj.certificado_curso_cfj" :error="form_cursos_cfj.errors.certificado_curso_cfj" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept=".docx,.pdf" label="Cargar Certificado" />

            </div>
            <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center mt-1">
                <button v-if="cursos" class="btn-login " tabindex="-1" type="button" @click="editar">Guardar Curso de Formacion Judicial</button>
                <button v-else class="btn-login " tabindex="-1" type="button" @click="save">Agregar Curso de Formacion Judicial</button>
                <button class="btn-register ml-auto" tabindex="-1" type="button" @click="cancelar">Cancelar</button>
            </div>
        </form>
    </div>
    
</template>

<script>

import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileInput from '@/Shared/FileInput'
import Icon from '@/Shared/Icon'


export default {
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
        FileInput,
        Icon,
    },
    props: {
        aspirante: Number,
        cursos:Object,
    },
    data(){
        return {
            form_cursos_cfj: this.$inertia.form({
                curso: '',
                descripcion: '',
                aspirante_id: this.aspirante,
                certificado_curso_cfj:null,
            })
        }
    },
    mounted(){
        if(this.cursos){
            this.form_cursos_cfj.curso = this.cursos.curso
            this.form_cursos_cfj.descripcion = this.cursos.descripcion
            this.form_cursos_cfj.certificado_curso_cfj = this.cursos.certificado_curso_cfj
        }
    },
    methods: {
        save() {
            this.form_cursos_cfj.post('/cursos_cfj',{
                _method: 'post',
                forceFormData: true,
                certificado_curso_cfj: this.form_cursos_cfj.certificado_curso_cfj,
                preserveScroll: true,
                onSuccess: () => this.$emit('guardarCurso')
            })
        },
        cancelar(){
            this.$emit('cancelarCurso')
        },
        editar(){
            this.form_cursos_cfj.post(`/cursos_cfj/${this.cursos.id}` ,{
                _method: 'put',
                preserveScroll: true,
                forceFormData: true,
                certificado_curso_cfj: this.form_cursos_cfj.certificado_curso_cfj,
                onSuccess: () => this.$emit('guardarCurso')
            }).url()
        }
    }
}
</script>